import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { DataUserService } from './data-user.service';

@Injectable({
  providedIn: 'root'
})
export class DataApiService {

  constructor( 
    private http:HttpClient,
    private DataUser:DataUserService
  ) { }

  public url =(location.hostname === "localhost" ) ? "http://localhost:8000/api" : "https://www.app.johnsonmiller.co/public/api";

  getUser(id){  return this.http.get(`${this.url}/dataUser/${id}`);  }
  
  getPrices(){   return this.http.get(`${this.url}/showPrices`);  }

  updatePrices(data){  return this.http.post(`${this.url}/updatePrices`,data); }


  showUsersConvenio(){return this.http.get(`${this.url}/showUsersConvenio`); }

  usuariosPrincipales(){return this.http.get(`${this.url}/mostrarUsuariosPrincipales`);}  

  descargarReporte(data){ return this.http.post(`${this.url}/descargarReporte`,data); }
  liquidar(data){ return this.http.post(`${this.url}/liquidar`,data); }

  //datos usuario por servicio
  verDatosUsuarioPorServicio(name,surname){
    return this.http.get(`${this.url}/verDatosUsuarioPorServicio/${name}/${surname}`);
  }

  //obtener horarios
  mostrarHorarios(fechaRecojo){
    return this.http.get(`${this.url}/mostrarHorarios/${fechaRecojo}`);
  }
  mostrarHorariosEntrega(horaRecojo){
    return this.http.get(`${this.url}/mostrarHorariosEntrega/${horaRecojo}`);
  }

  //crear usuarios motorizados
  crearUsuarioMotorizado(data){
    return this.http.post(`${this.url}/crearUsuarioMotorizado`,data)
  }
  editarUsuarioMotorizado(data){
    return this.http.post(`${this.url}/editarUsuarioMotorizado`,data)
  }
  //obtener firma payU
  obtenerFirmaPayU(data){
    return this.http.post(`${this.url}/obtenerFirmaPayU`,data)
  }

  //usuarios motorizado
  obtenerUsuariosMotorizados(){
    return this.http.get(`${this.url}/obtenerUsuariosMotorizados`)
  }
  asignarMotorizados(data){
    return this.http.post(`${this.url}/asignarMotorizados`,data)
  }
  //obtener solicitudes por motorizado
  getSolicitudesPorMotorizado(email){
    return this.http.get(`${this.url}/getSolicitudesPorMotorizado/${email}`)
  }

  //cambiar estado desde motorizado
  cambiarPedidoEstadoDesdeMotorizado(data){
    return this.http.post(`${this.url}/cambiarPedidoEstadoDesdeMotorizado`,data)
  }

  //cambiar perfiles

  perfilPersona(data){
    return this.http.post(`${this.url}/perfilPersona`,data)
  }

  perfilCompany(data){
    return this.http.post(`${this.url}/perfilCompany`,data)
  }
  //descargar reporte desde usuario
  descargarReporteDesdeUsuario(data){
    return this.http.post(`${this.url}/descargarReporteDesdeUsuario`,data)
  }
  //consultar cod desc

  consultarCodDesc(data){
    return this.http.post(`${this.url}/consultarCodDesc`,data)
  }

  aplicarDescuento(id_pedido,descuento,precio){
    return this.http.get(`${this.url}/aplicarDescuento/${id_pedido}/${descuento}/${precio}`)
  }

  crearCodigo(data){
    return this.http.post(`${this.url}/crearCodigo`,data)
  }

  consultarCambios(horaAtender){
    return this.http.get(`${this.url}/consultarCambios/${horaAtender}`)

  }
  tokenUser(token){   
    const base64Url = this.DataUser.dataUser(token).split('.')[1];
    const decodedValue = JSON.parse(window.atob(base64Url));
    return decodedValue.sub;
  }
}
